<template>
    <div style="height:100%;">
        <div class="error">
            <el-image :src="errorUrl" style="width: 450px;height: 500px;"></el-image>
            <div style="margin-left: 50px;">
                <div>糟糕，是无人之地。</div>
                <div>试试这些菜单导航一下吧~~</div>
            </div>
        </div>
    </div>
</template>

<script>
import empty from "@/assets/empty.jpeg";

export default {
    name: 'Desk',
    data() {
        return {
            errorUrl: empty,

        }
    },
    mounted() {

    },
}
</script>
<style scoped lang="scss">
.error {
    height: 100%;
    text-align: center;
    font-size: 42px;
    font-family: 400;
    color: cornflowerblue;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>